import React, { useState } from 'react';
import { getText } from '@storebrand-digital/fms-translations';
import { Button } from '@storebrand-digital/pretzel';

import styles from './Filter.Chips.module.css';
import { useIsMobile } from './hooks/useIsMobile';
import FilterChip from './Filter.Chip';
import DateChips from './Filter.Chips.DateChips';
import { useFilterChipsData } from './hooks/useFilterChipsData';

const MAX_VISIBLE_OTHER_CHIPS = 2;

function FilterChips() {
  const chips = useFilterChipsData();
  const [showAll, setShowAll] = useState(false);
  const { isMobile } = useIsMobile();
  const canCollapse = isMobile && chips.length > MAX_VISIBLE_OTHER_CHIPS;
  const visibleChipData =
    canCollapse && !showAll ? chips.slice(0, MAX_VISIBLE_OTHER_CHIPS) : chips;

  return (
    <div
      className={`${styles.filterChipsBase} chips`}
      role="region"
      aria-label={getText('activeFilters')}
    >
      <div className="chips-inner">
        <span className="font-body-sm" id="active-filters-label">
          {getText('activeFilters')}
        </span>
        <div
          className="chips-list"
          role="list"
          aria-labelledby="active-filters-label"
          aria-live="polite"
          aria-relevant="additions removals"
        >
          <DateChips />
          {canCollapse ? (
            <div className="chips-other-row">
              {visibleChipData.map((chip) => (
                <FilterChip
                  key={chip.key}
                  id={chip.id}
                  label={chip.label}
                  value={chip.value}
                  trackId={chip.trackId}
                  onRemove={chip.onRemove}
                />
              ))}
              <Button
                size="small"
                variant="subtle"
                aria-expanded={showAll}
                onClick={() => setShowAll((prev) => !prev)}
              >
                {showAll
                  ? getText('button.label.showLess')
                  : getText('button.label.showMore')}
              </Button>
            </div>
          ) : (
            visibleChipData.map((chip) => (
              <FilterChip
                key={chip.key}
                id={chip.id}
                label={chip.label}
                value={chip.value}
                trackId={chip.trackId}
                onRemove={chip.onRemove}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default FilterChips;
